import { useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import returnsServices from '@/returns/services/services'

const useResendPaymentLink = ({ returnId }) => {
  const [showPaymentLinkModal, setShowPaymentLinkModal] = useState(false)
  const { fetchData, loading } = useFetch(returnsServices.sendPaymentLink, { doInitialRequest: false })

  const resendPaymentLink = async () => {
    await fetchData({ returnId })
    setShowPaymentLinkModal(false)
  }

  const openPaymentLinkModal = () => {
    setShowPaymentLinkModal(true)
  }

  const closePaymentLinkModal = () => {
    setShowPaymentLinkModal(false)
  }

  return {
    showPaymentLinkModal,
    openPaymentLinkModal,
    closePaymentLinkModal,
    resendPaymentLink,
    sendingPaymentLink: loading,
  }
}

export default useResendPaymentLink
